/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';

export const GET_USER_PROFILE = gql`
  query GetUser($input: GetUserInput) {
    getUser(input: $input) {
      vuid
      userId
      firstName
      middleName
      lastName
      fullName
      emailVerified
      phoneVerified
      image
      accountStatus
      nationality
      role {
        name
        uuid
      }
      primaryContactNo
      createdAt
      trn
      email
    }
  }
`;
